module.exports = __webpack_public_path__ + "core-fonts/maxpro_s-light-webfont.f66631929e9a27a83821fb47a9fde4c6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/font/maxpro_s-light-webfont.woff
// module id = 18
// module chunks = 0